import { CharField, SingleSelectField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { NamedEntity } from "../../types"
import { NAMED_ENTITY_TYPES } from "../../constants"

export default function NamedEntityForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<NamedEntity>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.name}
        onChange={(value) => {
          setFieldValue("name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "name") : undefined}
        errorMessage={getIn(errors, "name")}
        required
      />

      <SingleSelectField
        label="Ruolo"
        layout="horizontal"
        placeholder="Seleziona un ruolo"
        options={NAMED_ENTITY_TYPES}
        value={NAMED_ENTITY_TYPES.find((type) => type.value === values.type) || null}
        onChange={(value) => {
          setFieldValue("type", value?.value || "")
        }}
        isValid={submitCount > 0 ? !getIn(errors, "type") : undefined}
        errorMessage={getIn(errors, "type")}
        required
      />

    </Col>
  )
}
